import GetCustomerOrderListRequestModelBase from '../_generated/modelBases/get-customer-order-list-request-model-base';

export default class GetCustomerOrderListRequestModel extends GetCustomerOrderListRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
